import { createSelector } from '@ngrx/store';

import { selectCertificationTypeState } from '../../../core.state';

export const selectCertificationTypes = createSelector(
    selectCertificationTypeState,
    state => state.items
);

export const selectCertificationTypesLoaded = createSelector(
    selectCertificationTypeState,
    state => state.loaded
);
